import { configureStore } from "@reduxjs/toolkit";
import bookButton from "store/bookButton/bookButtonSlice";
import currentUser from "store/currentUser/currentUserSlice";
import ui from "store/ui/uiSlice";
import letterbooks from "store/letterbooks/letterbooksSlice";
import search from "store/search/searchSlice";
import books from "store/books/booksSlice";

// Define the RootState type based on the shape of your reducers
export type RootState = {
  currentUser: ReturnType<typeof currentUser>;
  bookButton: ReturnType<typeof bookButton>;
  books: ReturnType<typeof books>;
  letterbooks: ReturnType<typeof letterbooks>;
  search: ReturnType<typeof search>;
  ui: ReturnType<typeof ui>;
};

const createStore = (preloadedState?: Partial<RootState>) => {
  return configureStore({
    reducer: {
      currentUser,
      bookButton,
      letterbooks,
      ui,
      search,
      books,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
      }),
    preloadedState,
  });
};

export { createStore };
export type AppDispatch = ReturnType<typeof createStore>['dispatch'];